/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminMeService {
    /**
     * Get current admin profile
     * Returns the authenticated admin profile. User ID is taken from the JWT token.
     * @returns any Admin profile retrieved
     * @throws ApiError
     */
    public static adminMeControllerGetMeV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/me',
            errors: {
                403: `Admin access required`,
                404: `Admin profile not found`,
            },
        });
    }
}
